export default [
  // generate random hex colors

  '#3498DB',
  '#01bd26',
  '#ba9b00',
  '#8E44AD',
  '#E67E22',
  '#3357FF',
  '#1ABC9C',
  '#c12200',
  '#7F8C8D',
  '#490700',
  '#F39C12',
  '#2C3E50'
];
